import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDateTime } from '../../../../utils/fmt';

const QuoteFollowUpListDetails = () => {
  const columns = [
    { label: 'Quote', value: 'quote' },
    { label: 'Scheduled At', value: (item) => fmtDateTime(item.scheduled_at) },
    { label: 'Outcome', value: 'outcome' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];
  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/quote/follow-up/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['quoteFollowUp']} />;
};

export default QuoteFollowUpListDetails;